
import React from 'react';
import { Check } from 'lucide-react';
import { PAYMENT_CONFIG, formatCurrency } from '../lib/paymentConfig';

const Compensation: React.FC = () => {
  return (
    <section className="py-24 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-extrabold mb-8 leading-tight">
              Transparent pay.<br />
              <span className="text-amber-400">No guesswork.</span>
            </h2>
            <p className="text-xl text-gray-400 mb-10 max-w-lg">
              We value your creativity and time. Our payout structure rewards high-quality content that engages our community on official brand channels.
            </p>

            <ul className="space-y-6">
              {[
                "Guaranteed monthly base pay",
                "Performance bonuses based on brand account reach",
                "No selling, no ads, no personal posting",
                "Focus purely on delivering great wellness content"
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-4">
                  <div className="mt-1 w-6 h-6 rounded-full bg-purple-500/20 flex items-center justify-center text-purple-400 shrink-0">
                    <Check className="w-4 h-4" strokeWidth={3} />
                  </div>
                  <span className="text-lg text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 lg:p-12 rounded-[2.5rem] border border-gray-700 shadow-2xl">
              <div className="space-y-8">
                <div className="pb-8 border-b border-gray-700">
                  <div className="text-amber-400 font-bold uppercase tracking-wider text-sm mb-2">Steady Income</div>
                  <div className="text-5xl font-black">{formatCurrency(PAYMENT_CONFIG.monthlyBase)}</div>
                  <div className="text-gray-400 text-lg mt-1">Guaranteed Monthly Base</div>
                </div>

                <div>
                  <div className="text-purple-400 font-bold uppercase tracking-wider text-sm mb-2">Brand Performance Bonus</div>
                  <div className="text-3xl font-black">+{formatCurrency(PAYMENT_CONFIG.cpmRate)} CPM</div>
                  <div className="text-gray-400 text-lg mt-1">Based on official account views</div>
                  <div className="text-xs text-gray-500 mt-2 italic">* 60-day bonus window · Capped at {formatCurrency(PAYMENT_CONFIG.maxBonusPerVideo)} per video</div>
                </div>
              </div>
            </div>

            {/* Decorative element */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-purple-500/10 rounded-full blur-2xl animate-pulse" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Compensation;
